var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { connect } from "react-redux";

import { getEvents } from "../../actions/events";
import { getStoriesStream } from "../../../actions/storiesStream";
import StoryCard from "../../../components/Library/StoryCard";
import StoriesStream from "../../../components/Library/StoriesStream";
import SectionContainer from "../../../components/Library/SectionContainer";
import Spinner from "../../../components/Library/Spinner";

var PassedEvents = function (_Component) {
  _inherits(PassedEvents, _Component);

  function PassedEvents() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PassedEvents);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PassedEvents.__proto__ || Object.getPrototypeOf(PassedEvents)).call.apply(_ref, [this].concat(args))), _this), _this.loadNextStories = function (page) {
      return _this.props.getStoriesStream({ stream: "events", page: page }, true);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PassedEvents, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.story) {
        this.props.getStoriesStream({ stream: "events" });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.story && !nextProps.story) {
        this.props.getStoriesStream({ stream: "events" });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          story = _props.story,
          storiesStream = _props.storiesStream;

      if (story) return React.createElement(StoryCard, { story: story });

      if (storiesStream.isLoading && storiesStream.results.length === 0) return React.createElement(Spinner, null);
      if (storiesStream.isFinished && storiesStream.results.length === 0) return null;

      return React.createElement(
        SectionContainer,
        { header: "Past Events" },
        React.createElement(StoriesStream, {
          stories: this.props.storiesStream,
          isEvent: true,
          showUnread: false,
          next: this.loadNextStories
        })
      );
    }
  }]);

  return PassedEvents;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    storiesStream: state.storiesStream,
    events: state.upcomingEvents
  };
};

var mapDispatchToProps = {
  getEvents: getEvents,
  getStoriesStream: getStoriesStream
};

export default connect(mapStateToProps, mapDispatchToProps)(PassedEvents);


// WEBPACK FOOTER //
// ./src/events/components/PassedEvents/PassedEvents.js